<template>
  <div class="panel-section">
    <div class="section-header">
      <h3 class="section-title">{{ $t('overview.workList.title') }}</h3>
      <span class="more-link" @click="goPage('/myworksheet/list', 'list')">{{ $t('overview.workList.moreLink') }}<i class="jc-icon-arrow-right"></i></span> 
    </div>
    <div class="ticket-list" v-if="tickets.length" v-loading="loading">
      <div class="ticket-item" v-for="(ticket, index) in tickets" :key="index" @click="goPage(ticket, 'detail')">
        <div class="ticket-header">
          <span class="ticket-id">{{ ticket.ticketNo }}</span>
          <span class="ticket-status-container" >
            <span class="ticket-status" :class="ticket.status">●</span>
            {{ getStatueText(ticket.status) }}
          </span>
        </div>
        <div class="ticket-title">{{ ticket.ticketName }}</div>
        <div class="ticket-time">{{ ticket.createdTime }}</div>
      </div>
    </div>
    <el-empty v-else :description="$t('text.noTicket')" :image-size="70"></el-empty>
  </div>
</template>

<script>
import submit from '../../../workSheet/SubmitWorkSheet';
export default {
  name: 'WorkOrderList',
  data() {
    return {
      loading: false,
      tickets: []
    }
  },

  computed: {
    worksheetMap () {
      const worksheetList = this.$store.state.wkMap.worksheetList;
      const statusList = worksheetList.all;
      const statusData = this._.keyBy(statusList, 'value');
      return statusData;
    },
  },
  mounted() {
    this.getTicketData();
  },

  methods: {
    getStatueText(status) {
      return this.worksheetMap[status].text;
    },
    goPage(item, type) {
      if (type === 'list') {
        this.$router.push({ 
          path: item,
        });
        return
      }
      let routePath = `/myworksheet/detail/${item.ticketNo}`;

      if (item.status === 'draft') {
        routePath = submit.methods.getRoute(item); 
      }
      this.$router.push({ 
        path: routePath,
        query: {
          idcLine: this.GLOBAL.idcLine,
          ticketNo: item.ticketNo,
        }
      });
    },
    getTicketData() {
      this.loading = true;
      const params = {
        pageNumber: this.currentPage,
        pageSize: 4,
        idcLine: this.GLOBAL.IDCLINE,
        type: this.selectType,
        isOpen: 1
      };
      this.$api.getWorkList(params).then(res => {
        if (res.errno === 10000 && res.data && res.data.tickets) {
          this.tickets = res.data.tickets;
        }
      }).finally(() => {
        this.loading = false
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.panel-section {
  background: #fff;
  padding: 24px;
  border-radius: 8px;

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .section-title {
      font-size: 14px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      margin: 0;
    }

    .more-link {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.45);
      text-decoration: none;
      cursor: pointer;
      &:hover {
        color: #1D41FF;
      }
    }
  }

  // Ticket List
  .ticket-list {
    .ticket-item {
      padding: 12px;
      // border-bottom: 1px solid #ebeef5;
      background: rgba(0, 0, 0, 0.02);
      border: none;
      border-radius: 4px;
      margin-top: 14px;

      &:last-child {
        border-bottom: none;
        padding-bottom: 0;
      }

      .ticket-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 6px;
        font-size: 12px;

        .ticket-id {
          color: #1D41FF;
          cursor: pointer;
        }

        .ticket-status-container {
          color: rgba(0, 0, 0, 0.65);
        }

        .ticket-status {
          &.draft { color: #FD7A22; }
          &.pendingClose { color: #FD7A22; } // Adjust colors as needed
          &.pendingReview { color: #FD7A22; }
          &.pendingVerification { color: #FD7A22; }
          &.processing { color: #FD7A22; }
          &.completed { color: #67c23a; }
          &.cancelled { color: #8C8C8C; }
          &.revoked { color: #8C8C8C; }
          &.rejected { color: #FF2C33; }
        }
      }

      .ticket-title {
        font-size: 13px;
        color: rgba(0, 0, 0, 0.85);
        margin-bottom: 2px;
        font-weight: bold;
      }

      .ticket-time {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.45);
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/resourceOverview/components/sidePanelComponents/WorkOrderList.vue